import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";

import { style } from "./style";

import DetailedAvailability from "../DetailedAvailability";
import Modal from "@/components/Modal";
import GetImages from "@/components/GetImages";
import BlockedAvailability from "../BlockedAvailability";
import Button from "@/components/Button";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  availabilitySettings,
  fetchAvailabilitySettingsListing,
  setIsBlockedBookingShown,
  setSelectedAvailabilitySettingDetail,
} from "@/store/slices/doctor/availabilitySettings";

import { IAvailabilitySetting } from "@/models/ApiRequestResponse/doctor";

import useIsMobile from "@/utils/hooks/useIsMobile";
import useIsTablet from "@/utils/hooks/useIsTablet";
import { getDateFormat, timeInAmPmFormat } from "@/utils";

const AvailabilitySlotsBooked: React.FC<IAvailabilitySetting> = (props) => {
  const { schedule_date, start_and_end_time, booked, total_slots, id } = props;
  const [showDetailedAvailability, setShowDetailedAvailability] =
    useState<boolean>(false);

  const { isMobile } = useIsMobile();
  const { isTablet } = useIsTablet();

  const isMobileOrTablet = isMobile || isTablet;
  const dispatch = useAppDispatch();
  const { isBlockedBookingShown, selectedAvailabilitySettingDetail } =
    useAppSelector(availabilitySettings);

  const handleShowDetailedAvailability = () => {
    dispatch(setSelectedAvailabilitySettingDetail(props));
    if (isMobileOrTablet) {
      setShowDetailedAvailability(!showDetailedAvailability);
    }
  };

  return (
    <>
      <Grid
        item
        sx={{
          ...style.container,
          backgroundColor: {
            md:
              selectedAvailabilitySettingDetail?.id === id
                ? "var(--warm-neutral-50)!important"
                : "transparent",
          },
        }}
        onClick={handleShowDetailedAvailability}
      >
        <Grid item display={"flex"} justifyContent={"space-between"}>
          <Typography component={"h5"} sx={style.appointmentDate}>
            {getDateFormat(schedule_date, "DD MMM, YYYY")}
          </Typography>
          <Grid item sx={style.totalBookedContainer}>
            <Typography component={"p"} sx={style.totalBooked}>
              {booked} Booked
            </Typography>
            <Grid item sx={style.slotContainer}>
              <Typography component={"p"}>Slot {total_slots}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Typography component={"p"} sx={style.appointmentTime}>
            {start_and_end_time
              ?.map(
                (time) =>
                  timeInAmPmFormat(time.start_time) +
                  " - " +
                  timeInAmPmFormat(time.end_time)
              )
              ?.join(", ")}
          </Typography>
        </Grid>
      </Grid>
      {showDetailedAvailability && (
        <DetailedAvailability
          isOpen={showDetailedAvailability}
          closeHandler={handleShowDetailedAvailability}
        />
      )}
    </>
  );
};

export default AvailabilitySlotsBooked;
